module.exports = __webpack_public_path__ + "static/media/advertencia2.d4301e06.PNG";